import React from 'react';
import { Row, Col, Divider } from 'antd';
import Modal from '../Modal/Modal';

const DetailItem = ({ name, value }) => {
  return (
    <Row justify="space-between">
      <Col>{name}</Col>
      {!Array.isArray(value) && <Col>{value}</Col>}
      {Array.isArray(value) && (
        <Col align="right">
          {value.map((item, index) => (
            <div key={index}>
              <span>{item}</span>
              <br />
            </div>
          ))}
        </Col>
      )}
    </Row>
  );
};

const DomainDetails = ({ visible, onCancel, info }) => {
  const { domain, registrar, expires, ns } = info;
  return (
    <div>
      <Modal
        handleClose={onCancel}
        isModalOpen={visible}
        styles={{
          width: '560px'
        }}
        titleContent={<h4 className="modal-title">{`Details (${domain})`}</h4>}
      >
        <div
          style={{
            border: '1px solid #D6D8E7',
            borderRadius: '8px',
            boxSizing: 'border-box',
            padding: '24px'
          }}
        >
          <DetailItem name="Registrar:" value={registrar} />
          <Divider />
          <DetailItem name="Expires:" value={expires ? new Date(expires).toLocaleString() : ''} />
          <Divider />
          <DetailItem name="Nameservers:" value={ns} />
        </div>
      </Modal>
    </div>
  );
};

export default DomainDetails;
